"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var paginationColors = function (colors) { return ({
    active: {
        background: colors.info[5],
        border: colors.info[5],
        color: '#ffffff',
    },
}); };
exports.default = paginationColors;
